import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { IStepData } from '~/src/features/mania/data';

import * as ST from './styled';

interface IProps {
    stepData: IStepData,
}

const Step = ({ stepData }: IProps): JSX.Element => {
    const { id, info, txtColor = COLORS.TextSecondary, bgColor = COLORS.BgSurface } = stepData;
    return (
        <ST.StepWrapper
            txtColor={txtColor}
            bgColor={bgColor}
            data-test='step-wrapper'
        >
            <ST.StepNumber>{id}</ST.StepNumber>
            <ST.StepInfo>{info}</ST.StepInfo>
        </ST.StepWrapper>
    );
};

export default Step;
